export const CORPORATE_PROGRAMME = 'corporate_reskilling';
export const YOUTH_PROGRAMME = 'youth_programme';

export const WORK_PROFILE_KEYS = [
  'job_title',
  'job_level',
  'division',
  'line_manager',
  'number_of_direct_reports',
  'total_years_of_experience',
  'years_in_current_role',
  'goals_or_objectives',
];

export const YOUTH_PROFILE_KEYS = [
  'highest_qualification',
  'nqf_level',
  'field_of_study',
  'host_employer',
  'workplace_mentor',
];

export const PROGRAMME_PROFILE_KEYS = [...WORK_PROFILE_KEYS, ...YOUTH_PROFILE_KEYS];

export const programmeTypeLabel = (project = {}) => {
  const typeLabel = project.programme_type_label || '';
  if (!typeLabel) return '';
  if (project.programme_type === YOUTH_PROGRAMME && project.programme_subtype_label) {
    return `${typeLabel} · ${project.programme_subtype_label}`;
  }
  return typeLabel;
};

export const normalizeProgrammeOptions = (response) => {
  const data = response?.data || response || {};
  return {
    programmeTypes: Array.isArray(data.programme_types) ? data.programme_types : [],
    programmeSubtypes: Array.isArray(data.programme_subtypes) ? data.programme_subtypes : [],
    subtypeRequiredFor: Array.isArray(data.subtype_required_for) ? data.subtype_required_for : [],
    deliveryProvinces: Array.isArray(data.delivery_provinces) ? data.delivery_provinces : [],
    deliveryModes: Array.isArray(data.delivery_modes) ? data.delivery_modes : [],
    profileFields: data.profile_fields && typeof data.profile_fields === 'object' ? data.profile_fields : {},
    programmeFieldsRequired: !!data.programme_fields_required,
  };
};

export const profileFieldsForProgramme = (options, programmeType, allowedKeys) => {
  const fields = options?.profileFields?.[programmeType];
  if (!Array.isArray(fields)) return [];
  const allowed = allowedKeys ? new Set(allowedKeys) : null;
  return fields
    .filter(field => field?.field && (!allowed || allowed.has(field.field)))
    .map(field => ({
      name: field.field,
      label: field.label || field.field,
      type: field.type === 'nqf_level' ? 'integer' : (field.type || 'text'),
      maxLength: field.max_length,
      min: field.min,
      max: field.max,
      multiline: field.type === 'textarea' || field.field === 'goals_or_objectives',
      fullWidth: field.type === 'textarea' || field.field === 'goals_or_objectives',
    }));
};

export const programmeTypeForProject = (project) => project?.programme_type || '';

export const clearInactiveProgrammeFields = (state, programmeType) => {
  const keep = new Set(
    programmeType === CORPORATE_PROGRAMME
      ? WORK_PROFILE_KEYS
      : programmeType === YOUTH_PROGRAMME ? YOUTH_PROFILE_KEYS : []
  );
  const nextState = PROGRAMME_PROFILE_KEYS.reduce((next, key) => {
    if (!keep.has(key)) next[key] = '';
    return next;
  }, { ...state });
  if (programmeType) {
    nextState.learner_category = '';
    nextState.employment_status = '';
  }
  return nextState;
};
